import { AxiosResponse } from "axios";

import { appConstants } from "../config/app-constants";
import {
  ICreateEFPlanTxn,
  ICreateEFilingPlanRes,
  IEfilingPlanTxnResponse,
  IFilingDocument,
  ITransactionListResponse,
  IVerifyCoupon
} from "../config/interfaces";
import InitApi from "./init";

class PurchasePlanApi {
  static _instance: PurchasePlanApi;

  static getInstance = () => {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new PurchasePlanApi();
    return this._instance;
  };

  _apiSvc;

  constructor() {
    this._apiSvc = InitApi.getInstance();
  }

  createEfilingPlan = async (data: {
    "efilingUuid": string;
    "planUuid": string;
  }): Promise<ICreateEFilingPlanRes> => {
    const url = `${appConstants.apiUrl}/efiling-plan`;
    const response = await this._apiSvc.post(url, data);
    return response.data;
  };

  verifyCouponCode = async (
    data: IVerifyCoupon
  ): Promise<{
    "subtotal": number;
    "discount": number;
  }> => {
    const url = `${appConstants.apiUrl}/coupon-code/verify`;
    const response = await this._apiSvc.post(url, data);
    return response.data;
  };

  getEFilingPlanPayableAmount = async (data: {
    "efilingUuid": string;
    "planUuid": string;
  }): Promise<{
    "subtotal": number;
    "discount": number;
  }> => {
    const response = await this._apiSvc.post(`${appConstants.apiUrl}/efiling-plan`, data);
    return response.data;
  };

  createEfilingPlanTransaction = async (
    data: ICreateEFPlanTxn
  ): Promise<IEfilingPlanTxnResponse> => {
    const url = `${appConstants.apiUrl}/efiling-plan-transaction`;
    const response = await this._apiSvc.post(url, data);
    return response.data;
  };

  updateEFilingTransaction = async (
    data: IFilingDocument,
    uuid: string
  ): Promise<AxiosResponse> => {
    const url = `${appConstants.apiUrl}/efiling-plan-transaction/single/${uuid}`;
    const response = await this._apiSvc.put(url, data);
    return response.data;
  };

  getEFilingAllTransactions = async (): Promise<ITransactionListResponse> => {
    const url = `${appConstants.apiUrl}/efiling-plan-transaction?offset=${0}&count=${-1}`;
    const response = await this._apiSvc.get(url);
    return response.data;
  };

  deleteEFilingTransaction = async (data: any): Promise<AxiosResponse> => {
    return this._apiSvc.delete(`${appConstants.apiUrl}/efiling-plan-transaction`, { data });
  };
}

export default PurchasePlanApi;
